"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _asObject = _interopRequireDefault(require("./lib/asObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MenuItem = function MenuItem(_ref) {
  var group = _ref.group,
      index = _ref.index,
      option = _ref.option,
      name = _ref.name,
      selected = _ref.selected,
      currentValue = _ref.currentValue,
      handleChange = _ref.handleChange;
  var elementId = "".concat(group, "-").concat(option.value);
  var className = 'menu-item' + (selected ? ' selected' : '') + (option.disabled ? ' disabled' : '');
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
    id: elementId,
    type: "radio",
    name: group,
    value: option.value,
    checked: selected,
    className: className,
    title: option.title,
    disabled: option.disabled,
    onChange: handleChange
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: elementId,
    title: option.title,
    className: className
  }, name));
};

var RadioButtons = function RadioButtons(_ref2) {
  var _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      value = _ref2.value,
      _ref2$group = _ref2.group,
      group = _ref2$group === void 0 ? 'radio-group' : _ref2$group,
      className = _ref2.className,
      onChange = _ref2.onChange;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: 'radio-buttons' + (' ' + group) + (className ? ' ' + className : '')
  }, options && options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(MenuItem, {
      key: index,
      index: index,
      group: group,
      option: (0, _asObject["default"])(option),
      name: (0, _asObject["default"])(option).name,
      currentValue: value,
      selected: (0, _asObject["default"])(option).value === value,
      handleChange: function handleChange(event) {
        return onChange((0, _asObject["default"])(option).value, index);
      }
    });
  }));
};

var _default = RadioButtons;
exports["default"] = _default;